import {float, extract} from '../utils.js';
import {uuid} from 'uuidv4';
import {doc} from '../../docs.js';

export const occlusion = (object, rayOrigin, rayDirection, distance, nor) => {
    let name = "ao" + uuid().replaceAll('-', '');
    return ([scene]) => {
        let {codes, uniforms, functions, variables} = extract(scene, rayOrigin, rayDirection, distance, nor); 
        functions[name] = {
            args: {
                "rayOrigin": "vec3",
                "rayDirection": "vec3",
                "distance": "float",
                "nor": "vec3",
            },
            returnType: "float",
            body: `
      vec3 pos = rayOrigin + rayDirection*distance;
      float occ = 0.0;
      float sca = 1.0;
      for( int i=0; i<5; i++ )
      {
          float hr = 0.01 + 0.12 * float( i ) / 4.0;
          vec3 aopos =  nor * hr + pos;
          float dd = ${scene.code(" aopos ")}.x;
          occ += -(dd-hr)*sca;
          sca *= 0.95;
      }
      return clamp( 1.0 - 3.0*occ, 0.0, 1.0 );    
`
        };
        let code = `${name}(${codes.slice(1).map(x => float(x)).join(',')})`;
        return {
            code,
            uniforms,
            functions,
            variables
        };
    }

};
